const blogsData = require('../api/blogs-data');
const boletinData = require('../api/boletin-data');

const SITE_NAME = 'H&A Abogados';
const SITE_URL = 'https://estudiohya.cl';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;
const DEFAULT_DESCRIPTION =
  'Estudio H&A Abogados, especialistas en derecho laboral, civil, penal, familia, administrativo, tributario, corporativo e inmobiliario.';

const opinionSeo = {
  'como-prevenir-y-proteger-la-salud-mental-de-sus-trabajadores': {
    description:
      'Artículo sobre la protección de la salud mental en el entorno laboral.',
  },
  'el-due-diligence-como-elemento': {
    description:
      'Análisis del Due Diligence como elemento esencial en el ámbito legal.',
  },
  'la-importancia-de-un-asesor-legal-en-establecimientos-educacionales': {
    description:
      'Discusión sobre la importancia de contar con asesoría legal en el ámbito educativo.',
  },
  'trato-escolar-ausente': {
    description: 'Artículo que explora la problemática del trato escolar ausente.',
  },
  'desregulacion-emocional-violencia-laboral-ley-21643': {
    description:
      'Análisis sobre la desregulación emocional y violencia laboral en el contexto de la ley 21643.',
  },
  'denunciar-y-esperar-ley-karin': {
    description:
      'A dos años de la Ley Karin, análisis sobre la protección que se decreta y no se cumple y la reparación que no llega al trabajador.',
    image: `${SITE_URL}/og/denunciar-y-esperar.jpg`,
  },
};

const boletinSeo = {
  'ley-karin-acoso-laboral': {
    description:
      'Análisis y discusión sobre la Ley Karin y su impacto en el acoso laboral.',
  },
};

const MONTHS = {
  enero: '01',
  febrero: '02',
  marzo: '03',
  abril: '04',
  mayo: '05',
  junio: '06',
  julio: '07',
  agosto: '08',
  septiembre: '09',
  octubre: '10',
  noviembre: '11',
  diciembre: '12',
};

function toIsoDate(createdAt) {
  const match = /^([A-Za-zÁÉÍÓÚáéíóúñÑ]+),\s*(\d{4})$/.exec(String(createdAt).trim());

  if (!match) {
    return undefined;
  }

  const month = MONTHS[match[1].toLowerCase()];

  return month ? `${match[2]}-${month}-01` : undefined;
}

// Mirrors src/api/attorneys.js, which cannot be required from Node because it imports images.
const teamMembers = [
  { id: '1', name: 'Pablo Hernández Arias (MBL)', title: 'CEO de H&A Abogados' },
  {
    id: '2',
    name: 'Daniela Sepúlveda Carvajal',
    title: 'Asesora Legal de H&A Abogados',
  },
  {
    id: '3',
    name: 'Vanessa Chávez Chacaltana',
    title: 'Consultora Externa de H&A Abogados',
  },
];

function teamRoutes() {
  return teamMembers.reduce((acc, member) => {
    acc[`/equipo/${member.id}`] = {
      title: `Perfil de ${member.name}`,
      description: `Perfil profesional de ${member.name}, ${member.title} en H&A Abogados.`,
    };

    return acc;
  }, {});
}

function articleRoutes(entries, basePath, seoBySlug) {
  return entries.reduce((acc, entry) => {
    const seo = seoBySlug[entry.webid] || {};

    acc[`${basePath}/${entry.webid}`] = {
      title: entry.title,
      description: seo.description,
      image: seo.image,
      type: 'article',
      author: entry.author,
      publishedTime: toIsoDate(entry.create_at),
    };

    return acc;
  }, {});
}

const routes = {
  '/': {
    title: 'Inicio',
    description:
      'Estudio H&A Abogados, especialistas en derecho laboral, civil, penal, familia, administrativo, tributario, corporativo, inmobiliario, entre otros.',
    localBusiness: true,
  },
  '/quienes-somos': {
    title: 'Quiénes Somos',
    description: 'Conozca más sobre el equipo y la historia de H&A Abogados.',
  },
  '/equipo': {
    title: 'Nuestro Equipo',
    description:
      'Conozca al equipo de abogados de H&A Abogados y su experiencia profesional.',
  },
  ...teamRoutes(),
  '/servicios': {
    title: 'Nuestros Servicios',
    description:
      'Conozca los servicios legales que ofrece H&A Abogados en diversas áreas del derecho.',
  },
  '/contacto': {
    title: 'Contacto',
    description: 'Póngase en contacto con H&A Abogados para consultas legales.',
  },
  '/asesoria': {
    title: 'Reserva tu Asesoría Jurídica',
    description:
      'Agenda tu cita de asesoría jurídica personalizada con Estudio H&A Abogados. Elige la fecha y hora que mejor se adapte a tu disponibilidad.',
  },
  '/opinion': {
    title: 'Columna de Opinión',
    description:
      'Lea los últimos artículos de opinión y análisis legal de H&A Abogados.',
  },
  ...articleRoutes(blogsData, '/opinion', opinionSeo),
  '/boletin': {
    title: 'Boletines',
    description:
      'Explora los boletines informativos de H&A Abogados sobre temas legales.',
  },
  ...articleRoutes(boletinData, '/boletin', boletinSeo),
  '/404': {
    title: 'Página no encontrada',
    description: 'La página solicitada no existe en H&A Abogados.',
    robots: 'noindex,follow',
    prerender: false,
  },
  '/payment/result': {
    title: 'Verificando Pago',
    description: 'Procesando confirmación de pago',
    robots: 'noindex,nofollow',
    prerender: false,
  },
  '/payment/success': {
    title: 'Pago Exitoso',
    description: 'Tu pago ha sido procesado exitosamente',
    robots: 'noindex,nofollow',
    prerender: false,
  },
  '/payment/error': {
    title: 'Error en el Pago',
    description: 'Ocurrió un problema con tu pago',
    robots: 'noindex,nofollow',
    prerender: false,
  },
};

function getRouteMeta(path) {
  const route = routes[path];

  if (!route) {
    throw new Error(`No SEO metadata registered for route "${path}"`);
  }

  return {
    title: route.title,
    description: route.description || DEFAULT_DESCRIPTION,
    canonical: `${SITE_URL}${path}`,
    image: route.image || DEFAULT_IMAGE,
    robots: route.robots || 'index,follow',
    type: route.type || 'website',
    author: route.author,
    publishedTime: route.publishedTime,
    localBusiness: route.localBusiness,
  };
}

function getPrerenderPaths() {
  return Object.keys(routes).filter((path) => routes[path].prerender !== false);
}

const SITEMAP_SETTINGS = {
  '/': { lastmod: '2026-09-27', changefreq: 'weekly', priority: '1.0' },
  '/quienes-somos': {
    lastmod: '2026-09-27',
    changefreq: 'monthly',
    priority: '0.8',
  },
  '/equipo': { lastmod: '2026-09-27', changefreq: 'monthly', priority: '0.7' },
  '/servicios': {
    lastmod: '2026-09-27',
    changefreq: 'monthly',
    priority: '0.9',
  },
  '/contacto': { lastmod: '2026-09-27', changefreq: 'yearly', priority: '0.5' },
  '/asesoria': {
    lastmod: '2026-09-27',
    changefreq: 'monthly',
    priority: '0.8',
  },
  '/opinion': { lastmod: '2026-09-27', changefreq: 'weekly', priority: '0.8' },
  '/boletin': { lastmod: '2026-09-27', changefreq: 'weekly', priority: '0.7' },
};

const TEAM_SITEMAP_SETTINGS = {
  lastmod: '2026-09-27',
  changefreq: 'monthly',
  priority: '0.5',
};

// Retired URLs served as 301 redirects by the S3 website endpoint (see scripts/deploy.sh).
const REDIRECTS = {
  '/opinion/denunciar-y-esperar-ley-karin-dos-anos':
    '/opinion/denunciar-y-esperar-ley-karin',
  '/home': '/',
  '/about': '/quienes-somos',
  '/faq': '/contacto',
  '/practice-single/1': '/servicios',
  '/practice-single/2': '/servicios',
  '/practice-single/3': '/servicios',
  '/practice-single/4': '/servicios',
};

const ARTICLE_SITEMAP_DEFAULTS = { changefreq: 'yearly', priority: '0.6' };

function getSitemapEntries() {
  return getPrerenderPaths().map((path) => {
    const route = routes[path];
    const settings = SITEMAP_SETTINGS[path];

    if (settings) {
      return { loc: `${SITE_URL}${path}`, ...settings };
    }

    if (path.startsWith('/equipo/')) {
      return { loc: `${SITE_URL}${path}`, ...TEAM_SITEMAP_SETTINGS };
    }

    return {
      loc: `${SITE_URL}${path}`,
      lastmod: route.publishedTime,
      ...ARTICLE_SITEMAP_DEFAULTS,
    };
  });
}

function buildArticleJsonLd(meta) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: meta.title,
    description: meta.description,
    image: meta.image,
    mainEntityOfPage: { '@type': 'WebPage', '@id': meta.canonical },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: { '@type': 'ImageObject', url: DEFAULT_IMAGE },
    },
  };

  if (meta.author) {
    data.author = { '@type': 'Person', name: meta.author };
  }

  if (meta.publishedTime) {
    data.datePublished = meta.publishedTime;
  }

  return data;
}

// Must match the Google Business Profile exactly (name, address, phone).
function buildLegalServiceJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    '@id': `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    logo: DEFAULT_IMAGE,
    image: DEFAULT_IMAGE,
    description: DEFAULT_DESCRIPTION,
    telephone: '+56232451291',
    email: 'contacto@estudiohya.cl',
    foundingDate: '2014',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Av. Pedro de Valdivia 1210, Oficina 404',
      addressLocality: 'Providencia',
      addressRegion: 'Región Metropolitana',
      postalCode: '8320000',
      addressCountry: 'CL',
    },
    areaServed: { '@type': 'Country', name: 'Chile' },
    knowsAbout: [
      'Derecho laboral',
      'Derecho civil',
      'Derecho penal',
      'Derecho de familia',
      'Derecho administrativo',
      'Derecho tributario',
      'Derecho corporativo',
      'Derecho inmobiliario',
      'Derecho educacional',
    ],
    sameAs: ['https://www.linkedin.com/company/hyaabogados'],
  };
}

function getJsonLd(meta) {
  if (meta.type === 'article') {
    return buildArticleJsonLd(meta);
  }

  if (meta.localBusiness) {
    return buildLegalServiceJsonLd();
  }

  return null;
}

module.exports = {
  SITE_NAME,
  SITE_URL,
  DEFAULT_IMAGE,
  DEFAULT_DESCRIPTION,
  routes,
  REDIRECTS,
  getRouteMeta,
  getPrerenderPaths,
  getSitemapEntries,
  getJsonLd,
};
